export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Portfolio.components.Workspace.components.Blocks.DetrimentalEvents.components.Tabs.components.Tab'
